import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const TechnologiesContext = createContext();

export const useTechnologiesData = () => {
    return useContext(TechnologiesContext);
};

export const TechnologiesProvider = ({ children }) => {
    const [technologies, setTechnologies] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchTechnologies = async () => {
        try {
            setLoading(true);
            const records = await pb.collection('technologies').getFullList({
                sort: 'order',
            });
            setTechnologies(records);
        } catch (error) {
            console.error('Error fetching technologies:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTechnologies();

        // Real-time subscription
        pb.collection('technologies').subscribe('*', (e) => {
            if (e.action === 'create') {
                setTechnologies(prev => [...prev, e.record].sort((a, b) => a.order - b.order));
            } else if (e.action === 'delete') {
                setTechnologies(prev => prev.filter(item => item.id !== e.record.id));
            } else if (e.action === 'update') {
                setTechnologies(prev => prev.map(item => item.id === e.record.id ? e.record : item).sort((a, b) => a.order - b.order));
            }
        });

        return () => {
            pb.collection('technologies').unsubscribe('*');
        };
    }, []);

    const value = {
        technologies,
        loading,
        refresh: fetchTechnologies
    };

    return (
        <TechnologiesContext.Provider value={value}>
            {children}
        </TechnologiesContext.Provider>
    );
};
